import React from 'react';

import { RECTANGLE, ELLIPSE, DEFAULT_SHAPE_PADDING } from '@/constants';

const Shape = props => {
  const { id, rectProps, formatProps } = props;
  const { shape, shapeStrokeColor, shapeFillColor } = formatProps;

  const strokeColor = shape.hasStroke ? shapeStrokeColor : 'none';
  const strokeWidth = shape.hasStroke ? shape.strokeWidth : 'none';
  const strokeDasharray = shape.isDashed ? `${3 * shape.strokeWidth} ${shape.strokeWidth}` : 'none';
  const fill = shape.isFilled ? shapeFillColor : 'transparent';

  switch (shape.name) {
    case RECTANGLE: {
      const w = (shape.hasStroke ? rectProps.width - shape.strokeWidth : rectProps.width) - (DEFAULT_SHAPE_PADDING * 2);
      const h = (shape.hasStroke ? rectProps.height - shape.strokeWidth : rectProps.height) - (DEFAULT_SHAPE_PADDING * 2);
      const x = (shape.hasStroke ? rectProps.x + shape.strokeWidth / 2 : rectProps.x) + DEFAULT_SHAPE_PADDING;
      const y = (shape.hasStroke ? rectProps.y + shape.strokeWidth / 2 : rectProps.y) + DEFAULT_SHAPE_PADDING;
      const rx = shape.softEdges ? shape.cornerRadius : 0;

      return <rect id={id} x={x} y={y} width={w} height={h} stroke={strokeColor} strokeWidth={strokeWidth} strokeDasharray={strokeDasharray} rx={rx} fill={fill} />;
    }
    case ELLIPSE: {
      const cx = shape.hasStroke ? rectProps.x + (rectProps.width / 2) : rectProps.x + (rectProps.width / 2);
      const cy = shape.hasStroke ? rectProps.y + (rectProps.height / 2) : rectProps.y + (rectProps.height / 2);
      const rx = (shape.hasStroke ? (rectProps.width / 2) - (shape.strokeWidth / 2) : rectProps.width / 2) - DEFAULT_SHAPE_PADDING;
      const ry = (shape.hasStroke ? (rectProps.height / 2) - (shape.strokeWidth / 2) : rectProps.height / 2) - DEFAULT_SHAPE_PADDING;

      return <ellipse cx={cx} cy={cy} rx={rx} ry={ry} fill={fill} stroke={strokeColor} strokeWidth={strokeWidth} strokeDasharray={strokeDasharray} />;
    }
    default: {
      return null;
    }
  }
};

export default Shape;
